import { useQuery } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';
import type {
  GetArAgingInput,
  GetArAgingResponse,
  ArAgingCustomerRow,
  ArAgingTotals,
  AgingBucketDefinition,
} from '@erp/rpc';

export function useArAging(filters: GetArAgingInput = {}, enabled = true) {
  const query = useQuery({
    ...orpc.accountsReceivable.arAging.get.queryOptions({
      input: filters,
    }),
    enabled,
  });

  const customers = query.data?.customers ?? [];
  const totals = query.data?.totals ?? null;
  const bucketDefinitions = query.data?.bucketDefinitions ?? [];

  return {
    ...query,
    customers,
    totals,
    bucketDefinitions,
  } satisfies typeof query & {
    data?: GetArAgingResponse;
    customers: ArAgingCustomerRow[];
    totals: ArAgingTotals | null;
    bucketDefinitions: AgingBucketDefinition[];
  };
}
